import { WHY_CHOOSE_US_QUERY } from "@/apollo/queries";
import Banner from "@/components/Banner";
import SimpleCard from "@/components/Card";
import Loader from "@/components/Loader";
import SEOHead from "@/components/SEO";
import { useQuery } from "@apollo/client";
import {
  Box,
  Container,
  Flex,
  Grid,
  Text,
  //image
} from "@chakra-ui/react";
import React from "react";
import Image from "next/image";

const WhyChooseUS = (props) => {
  const { loading, error, data } = useQuery(WHY_CHOOSE_US_QUERY);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    console.error(error);
    return null;
  }

  const { MainSec, Contact_Us, Sections, SEO } =
    data.whyChooseUs.data.attributes;

  return (
    <>
      <SEOHead title={SEO.pageTitle} description={SEO.pageDescription} />
      <Banner data={MainSec} classNameparent="chooseOverlay" />
      <Box
        as={Container}
        maxW="7xl"
        mt={{ base: 14, md: 16, lg: 20}}
        px={{ base: 5,md: 8, xl:5}}
      >
        <Flex wrap={"wrap"} justify={"center"} textAlign={"center"}>
          {Sections.map((item, index) => {
            const { Title, Description, TitleIconSection, slug, image } = item;
            return (
              <Box  key={index}>
                {image.data ? (
                  <Flex
                    mb={{ base: 8, md: 10, lg: 16 }}
                    gap={8}
                    alignItems={"center"}
                    flexDirection={{ base: "column", md: "column", lg: "row" }}
                  >
                    <Image
                      height={700}
                      width={560}
                      src={
                        process.env.NEXT_PUBLIC_SERVER_URL +
                        image?.data?.attributes.url
                      }
                      alt={image?.data?.attributes.name}
                      style={{
                        objectFit: "cover",
                        borderRadius: "1rem",
                        margin: "auto",
                      }}
                    />
                    <Box
                      textAlign={{ base: "center", md: "center", lg: "start" }} maxW={{base:"full",md:"full",lg:"50%"}}
                    >
                      <Text
                        fontSize={{ base: "2xl", md: "3xl" }}
                        mb={3}
                        fontWeight={500}
                        color={"blue.10"}
                      >
                        {Title}
                      </Text>
                      <Text fontWeight={"normal"} color={"gray.10"}   fontSize={"lg"}> 
                        {Description}
                      </Text>
                    </Box>
                  </Flex>
                ) : (
                  <Text
                    fontSize={"3xl"}
                    mt={{ base: 0, md: 5 }}
                    mb={{ base: 10, md: 12 }}
                    fontWeight={500}
                    lineHeight={10}
                    color={"blue.10"}
                  >
                    {Title}
                  </Text>
                )}
                
                <Grid
                  templateColumns={{
                    base: "repeat(1, 1fr)",
                    sm: "repeat(2, 1fr)",
                    md: "repeat(2, 1fr)",
                    lg: "repeat(3, 1fr)",
                    xl: "repeat(4, 1fr)"
                  }}
                  gap={6}
                  mb={slug == "reasons" ? 0 : 12}
                  justifyItems={"center"}
                >
                  {TitleIconSection.map((ele, index) => {
                    return slug == "reasons" ? (
                      <Flex
                        flexDirection={"column"}
                        key={index}
                        align={"center"}
                        textAlign={"center"}
                        gap={"5"}
                        alignItems={"center"}
                      >
                        <Box>
                          <Image
                            width={80}
                            height={60}
                            style={{ objectFit: "scale-down", margin: "auto" }}
                            src={
                              process.env.NEXT_PUBLIC_SERVER_URL +
                              ele.Icon?.data?.attributes.url
                            }
                            alt={ele.Icon?.data?.attributes.name}
                          />
                        </Box>
                        <Box textAlign={"center"}>
                          <Text
                            fontSize={"md"}
                            fontWeight={500}
                            color={"blue.10"}
                          >
                            {" "}
                            {ele.Title}
                          </Text>
                        </Box>
                      </Flex>
                    ) : (
                      <SimpleCard data={ele} showIcon={true} />
                    );
                  })}
                </Grid>
              </Box>
            );
          })}
        </Flex>
      </Box>
      <Banner
        data={Contact_Us}
        classNamechild
      />
    </>
  );
};

export default WhyChooseUS;
